module.exports = __WEBPACK_EXTERNAL_MODULE_react_state_effects__;